export default __webpack_public_path__ + "static/media/login_1.b51417d3.png";